require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-heather-cherewaty.json") })
        }
      }, "path---blog-author-heather-cherewaty");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-heather-cherewaty!./.cache/json/blog-author-heather-cherewaty.json
// module id = 644
// module chunks = 231608221292675